

import React from 'react';
import _ from 'lodash';
import { cancelMarketingCampaign, getMarketingCampaigns } from '../../apis/backend';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { showNotification } from '../../components/Notification/Notification.view';
import { SUCCESS_UPDATE_TEXT, ERROR_CANCEL_CAMPAIGN_TEXT } from '../../constants';
import { CAMPAIGN_ITEMS, MARKETING_CAMPAIGN_STATUS, CAMPAIGN_TYPES } from '../../constants/marketingCampaign';
import moment from 'moment';
export type CampaignStatus = typeof MARKETING_CAMPAIGN_STATUS[keyof typeof MARKETING_CAMPAIGN_STATUS];

export interface Campaign {
    id: string;
    type: keyof typeof CAMPAIGN_TYPES;
    status: CampaignStatus;
    dateStart: string;
    dateEnd: string;
}
export const handleClick = (event, setAnchorEl) => {
    setAnchorEl(event.currentTarget);
};
export const getAllCampaigns = async (setMarketingCampaigns, status) => {
    try {
        const campaigns = await getMarketingCampaigns(status);
        const formattedCampaigns = _.map(campaigns, campaign => ({
            ...campaign,
            marketingCampaignKey: campaign.key
        }));
        setMarketingCampaigns(formattedCampaigns);
    } catch (error) {
        console.error('Error fetching marketingCampaigns', error);
    }
}
export const handleRowClick = (campaign, setSelectedCampaign) => {
    setSelectedCampaign(campaign);
};
export const handleClose = (setAnchorEl) => {
    setAnchorEl(null);
};
export const handleDisabledCampaign = (selectedCampaign, showModal, openErrorModal, setMarketingCampaigns, setChangedCampaign) => {
    const { title } = CAMPAIGN_ITEMS.filter(item => selectedCampaign?.type === item.id)[0];

    const firstModalData = {
        color: 'success',
        title: `Désactiver la campagne`,
        message: ` Voulez-vous désactiver la campagne "${title}" ?`,
        showCancelBtn: true,
        handleClose: () => {
            showModal(null);
        },
        btnColor: 'success',
        onClick: () => {
            const secondModalData = {
                color: 'success',
                title: `Désactiver la campagne`,
                message: `Êtes-vous  sûr(e) de vouloir désactiver la campagne "${title}" ? Cette action est irréversible`,
                showCancelBtn: true,
                handleClose: () => {
                    showModal(null);
                },
                btnColor: 'success',
                onClick: async () => {
                    showModal({ ...secondModalData, loading: true });
                    await handleCancelMarketingCampaign(selectedCampaign?.marketingCampaignKey, showModal, openErrorModal, setMarketingCampaigns, setChangedCampaign);


                },
                btnTxt: 'Désactiver'
            };
            showModal(secondModalData);
        },
        btnTxt: 'Continuer'
    };
    showModal(firstModalData);
};
export const handleCancelMarketingCampaign = async (campaignKey, showModal, openErrorModal, setMarketingCampaigns, setChangedCampaign) => {
    try {
        await cancelMarketingCampaign(campaignKey);
        await getAllCampaigns(setMarketingCampaigns, [MARKETING_CAMPAIGN_STATUS.PENDING])
        setChangedCampaign(true)
        showNotification(
            'light',
            'ltr',
            'primary',
            SUCCESS_UPDATE_TEXT,
            `La campagne a été bien annulée`
        );
        showModal(null);
    } catch (e) {
        openErrorModal(ERROR_CANCEL_CAMPAIGN_TEXT);
        sendCloudWatchAlert(`Error when cancel campaign ${e}`);
    }
    finally {
        showModal(null);
    }
};



export const filterAndSortCampaigns = async (
    campaigns: Campaign[],
    tabSelected: number,
    setIsLoadingCompletedCampaigns,
    completedCampaigns: Campaign[],
    changedCampaign: boolean,
    setChangedCampaign,
    setCompletedCampaigns: React.Dispatch<React.SetStateAction<Campaign[]>>
): Promise<Campaign[]> => {
    let filtered: Campaign[] = [];
    switch (tabSelected) {
        case 0:
            filtered = campaigns.filter(c => c.status === MARKETING_CAMPAIGN_STATUS.IN_PROGRESS);
            filtered.sort((a, b) =>
                moment(a.dateEnd).diff(moment(b.dateEnd))
            );
            break;

        case 1:
            filtered = campaigns.filter(c => c.status === MARKETING_CAMPAIGN_STATUS.NOT_STARTED);
            filtered.sort((a, b) =>
                moment(a.dateStart).diff(moment(b.dateStart))
            );
            break;

        case 2:
            if (completedCampaigns.length === 0 || changedCampaign) {
                setChangedCampaign(false)
                setIsLoadingCompletedCampaigns(true);
                const fetched = await getMarketingCampaigns([MARKETING_CAMPAIGN_STATUS.COMPLETED]);
                const mapped = _.map(fetched, campaign => ({
                    ...campaign,
                    marketingCampaignKey: campaign.key
                }));
                setCompletedCampaigns(mapped);
                filtered = mapped;
                setIsLoadingCompletedCampaigns(false);

            } else {
                filtered = completedCampaigns;
            }

            filtered.sort((a, b) =>

                moment(b.dateStart).diff(moment(a.dateStart))
            );
            setIsLoadingCompletedCampaigns(false)
            break;

        default:
            filtered = campaigns;
            break;
    }
    return filtered;
};


export const onChangeData = async (e, value, setStatusSelected, props) => {
    props.initPage(props.rowsPerPage);
    setStatusSelected(value);

};